/**
 * Gets the list of currencies that are eligible for a tenant by filtering out already allocated currencies
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.tenantCurrencies - Object containing an array of tenant's current currencies in rows property
 * @param {Object} params.allCurrencies - Object containing an array of all available currencies in rows property
 * @returns {Array} Array of eligible currencies that can be allocated to the tenant
 */
export const getTenantEligibleCurrencies = ({ tenantCurrencies, allCurrencies }) => {
  if (allCurrencies?.rows?.length && tenantCurrencies?.rows.length) {
    const allottedTenantCurrencies = tenantCurrencies?.rows?.map(({ code }) => code)
    // Filtering out all the already added currencies so that they cannot be selected again.
    return allCurrencies?.rows?.filter(({ code }) => !allottedTenantCurrencies.includes(code))
  }
  if (allCurrencies?.rows?.length) {
    // This is the case for a new tenant when no currency has been added. In that case, we need to display all.
    return allCurrencies?.rows
  }
  return []
}
